import React, { useEffect } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { useCity } from '../city.hook';
import { CityRequest } from '../../../request/city.request';
import { validateLevel, validateLevelName } from '../../../validator/level.validator';
import { handleFilter } from '../../../view/input.helper';
import { ItemProp } from '../../../model/item-prop.model';
import { CountryRes } from '../../../response/country.response';
import FileUploadView from '../../../view/file-upload.view';
import { Media } from '../../../model/media.model';
import LocationPickerView from '../../../view/location-picker.view';
import { Location } from '../../../model/location.model';

export const AddCityComponent: React.FC<{ open: boolean, onCancel: () => void }> = ({ open, onCancel }) => {
    const [form] = Form.useForm();
    const { loading, countryList, updateLoading, saveCity, fetchCountryList } = useCity()

    const handleOk = () => {
        form.validateFields().then(values => {
            updateLoading(true);
            const cityRequest = {
                name: values["name"],
                countryId: values["countryId"],
                location: values["location"],
                thumbnail: values["thumbnail"],
                tint: values["tint"],
                order: Number(values["order"])
            } as CityRequest
            saveCity(cityRequest, onSuccess, onFailure)
        });
    };

    const onSuccess = () => {
        updateLoading(false);
        form.resetFields()
        onCancel();
    }

    const onFailure = () => {
        updateLoading(false);
    }

    useEffect(() => {
        fetchCountryList()
    }, [])

    return (
        <Modal
            open={open}
            title="Add New City"
            onCancel={onCancel}
            confirmLoading={loading}
            onOk={handleOk}
            okText={"Submit"}
            cancelText={"Cancel"}
            style={{ top: 8, maxWidth: 768 }}
            width={'90vw'}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, validator: validateLevelName }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="tint"
                    label="Tint Color"
                    rules={[{ required: true}]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="countryId"
                    label="Country"
                    rules={[{ required: true, message: 'Country Id' }]}
                >
                    <Select
                        showSearch={true}
                        value='countryId'
                        options={countryList.map((countryRes: CountryRes) => {
                            return {
                                label: `${countryRes.name}`,
                                value: countryRes.id
                            } as ItemProp
                        })}
                        filterOption={handleFilter} />
                </Form.Item>

                <Form.Item
                    name="order"
                    label="Order"
                    rules={[{ required: true, validator: validateLevel }]}
                >
                    <Input placeholder="Enter order" />
                </Form.Item>

                <Form.Item
                    name="thumbnail"
                    label="Thumbnail"
                    rules={[{ required: true, message: 'Please add thumbnail' }]}
                >
                    <FileUploadView onChange={(media: Media) => { }} />
                </Form.Item>

                <Form.Item
                    name="location"
                    label="Location"
                    rules={[{ required: true, message: 'Please add location' }]}
                >
                    <LocationPickerView onChange={(location: Location) => { }} />
                </Form.Item>

            </Form>
        </Modal>
    );
}